package uz.ferro.erp.ui.table

import react.ReactNode
import web.cssom.BackgroundColor
import web.cssom.TextAlign

data class CellItem(
    val title: String? = null,
    val content: ReactNode? = null,
    val textBackgroundColor: BackgroundColor? = null,
    val textAlign: TextAlign? = null
)
